/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_SettingsInputs */



/**
* | output |
* | --- |
* | "Sound settings" |
*
* @param {Practice_Session_SettingsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_settings = /** @type {((inputs?: Practice_Session_SettingsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_SettingsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geluidsinstellingen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réglages audio")
	return /** @type {LocalizedString} */ ("Sound settings")
});